// @flow
import * as React from 'react';
import styled from 'styled-components';
import {
	ModalContainer,
} from '../../components';
import CoachHeaderBg from '../../assets/images/coach-header.jpg';
import colors from "../../assets/css/colors";
import { below } from '../../assets/css/media';
// import _ from 'lodash';

const CoachPopupInner = styled.div`
	background: #FFF;
	width: 488px;
	text-align: left;
		${below.desktop`
			width: auto;
		`}


`;
const CoachPopupHeader = styled.div`
		background-image: url(${CoachHeaderBg});
		background-repeat: no-repeat;
		background-position: center center;
		background-size: cover;
		background-color: #8E3BC7;
		color: #FFF;
		font-size: 30px;
		line-height: 34px;
		padding: 100px 75px 20px 40px;
		text-transform: uppercase;
		${below.desktop`
			font-size: 18px;
		`}

`;
const CoachPopupBody = styled.div`
		background: #FFF;
		padding: 40px;
		color: #000;
		box-shadow: 0 10px 15px 0 rgba(0,0,0,0.24);
		h3{

			font-size: 24px;
			line-height: 28px;
			text-transform: uppercase;
			margin-bottom: 15px;

		}

		p{
			font-size: 14px;
			color: ${colors.coach_poup_body_text};
			margin-bottom: 15px;
			font-weight: 400;
			line-height: 1.4;
		}
`;
const CoachPopupBodyButtons = styled.div`
			display: flex;
			justify-content: space-between;
			align-items: center;
`;

const CoachPopUpButton = styled.a`
		width: 47%;
		cursor: pointer;
		height: 35px;
		padding: 0 1em;
		font-size: .65em;
		font-weight: bold;
		text-transform: uppercase;
		text-align: center;
		border-radius: .4em;
		letter-spacing: 1px;
		transition: all 0.2s ease-out;
		text-decoration: none;
		line-height: 34px;
		&.more{
			background: transparent;
			color: #000;
			border: 1px solid #003A31;
			&.active-btn, &:hover{
					background: #003A31;
					border-color: #003A31;
					color: #FFF;
				}
		}

		&.sign-up{
			background: #6E16AA;
			color: #FFF;
			border: 1px solid #6E16AA;
			&.active-btn, &:hover{
					background: transparent;
					border-color: #6E16AA;
					color:#000;
				}

			}
		${below.desktop`
			line-height: 17px;
			padding: 1em 0;
			font-size: 10px;
		`}

`;


type Props = {
	closeClick: Function,
};

export class CoachPopup extends React.Component<Props> {
	render() {
		return (
			<ModalContainer
				onClick={this.props.closeClick}
				is_sponsored={false}
				popup_width={'auto'}
				body_class={'coach-popup'}
			>
				<CoachPopupInner>
					<CoachPopupHeader>
						Give your team the edge with coach
					</CoachPopupHeader>
					<CoachPopupBody>
						<h3>sign up today<br/>What is Coach?</h3>
						<p>Coach is your premium Fantasy product fully integrated
							across the site	and app to provide you with the extra
							stats and info needed to improve your team! It gives
							you the best chance at winning your league and possibly
							some great prizes!</p>
						<p>Check out all our key features for more information.</p>
						<CoachPopupBodyButtons>
							<CoachPopUpButton
								href="/help/guidelines#coach"
								className={'more'}
								target="_blank"
							>FIND OUT MORE
							</CoachPopUpButton>
							<CoachPopUpButton
								href="/account/coach-settings"
								className={'sign-up'}
								target="_blank"
							>Sign me up
							</CoachPopUpButton>
						</CoachPopupBodyButtons>
					</CoachPopupBody>
				</CoachPopupInner>
			</ModalContainer>
		);
	}
}

export default CoachPopup;


// WEBPACK FOOTER //
// ./src/components/CoachPopup/index.js